var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTravellingNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 12H4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2M4 10a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.505 3h-9.01a2 2 0 0 0-1.96 1.604L4.445 10h15.11l-1.09-5.396A2 2 0 0 0 16.505 3m3.92 1.208A4 4 0 0 0 16.506 1h-9.01a4 4 0 0 0-3.92 3.208L2 12h20z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 20a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM4 15.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 15.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M17 20a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14 9a2 2 0 0 0-2 2h-2a4 4 0 0 1 8 0h-2a2 2 0 0 0-2-2",
  clipRule: "evenodd"
})));
export default SvgTravellingNew;